import { Component, OnInit, HostListener } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { CommonService } from "src/app/services/common.service";
import { appConstants } from "src/app/constants/appConstants";
import { MatDialogRef } from "@angular/material";

@Component({
  selector: "app-payment-details",
  templateUrl: "./payment-details.component.html",
  styleUrls: ["./payment-details.component.scss"],
})
export class PaymentDetailsComponent implements OnInit {
  public title: string;
  public message: string;

  constructor(
    private _commonService: CommonService,
    private _router: Router,
    private _route: ActivatedRoute,
    public dialogRef: MatDialogRef<PaymentDetailsComponent>
  ) {}
  showScroll: boolean;
  showScrollHeight = 300;
  hideScrollHeight = 10;
  @HostListener("window:scroll", [])
  onWindowScroll() {
    if (
      (window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop) > this.showScrollHeight
    ) {
      this.showScroll = true;
    } else if (
      this.showScroll &&
      (window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop) < this.hideScrollHeight
    ) {
      this.showScroll = false;
    }
  }

  scrollToTop() {
    (function smoothscroll() {
      var currentScroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(smoothscroll);
        window.scrollTo(0, currentScroll - currentScroll / 5);
      }
    })();
  }
  pageLimit: number[] = [5, 10, 25, 50, 100];
  page: number = 1;
  total_page: number = 1;
  pageSize: number = 50;
  PaymentList: Array<any> = [];
  ngOnInit() {
    if (this.title) {
      let Id = this.title;
      this.getPaymentDetail(this.title);
    }
  }
  getPaymentDetail(id) {
    let url = appConstants.PAYMENT_DETAIL + id;
    this._commonService.getRequest(url).subscribe(
      (res) => {
        this.PaymentList = res;
      },
      (err) => {
        console.log("err", err);
      }
    );
  }
}
